import { StaticScreenProps, useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { Button, Form, Input, TextInput } from "../lib";
import { useBookingReport, useServerForm, useUser } from "../services";
import { Banner } from "../components";

type Props = StaticScreenProps<{
  id: number;
}>;

const initialValues = {
  message: "",
};

export function BookingReportScreen({ route }: Props) {
  // Params
  const { id } = route.params;

  // Data
  const { data: user } = useUser();
  const [reportBooking, isUpdating, error] = useBookingReport({ id });

  // Vars
  const navigation = useNavigation();
  const { values, setValue } = useServerForm(initialValues, error);

  // Handlers
  const handleSubmit = useCallback(async () => {
    await reportBooking({ message: values.message });

    navigation.goBack();
  }, [navigation, reportBooking, values.message]);

  return (
    <>
      <Banner
        message="Please use this space to report FAKE and BAD clients only"
        mb="8"
      />
      <Form>
        <Input label="Reason">
          <TextInput
            name="message"
            placeholder="Reason for reporting client"
            onChange={setValue}
            value={values.message}
            multiline
            numberOfLines={10}
          />
        </Input>

        <Button
          disabled={!user?.independent || !values.message}
          onPress={handleSubmit}
          loading={isUpdating}
        >
          Report Problem
        </Button>
      </Form>
    </>
  );
}
